import { render } from "./DualComparison.vue?vue&type=template&id=6920a415&scoped=true"
import script from "./DualComparison.vue?vue&type=script&lang=js"
export * from "./DualComparison.vue?vue&type=script&lang=js"

import "./DualComparison.vue?vue&type=style&index=0&id=6920a415&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6920a415"]])

export default __exports__